import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";
import { TagValue, TagValueFormData } from "../../../types/tag";

export const useCreateTagValue = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (data: TagValueFormData): Promise<TagValue> => {
            const { tagTypeId, ...rest } = data;
            const payload = {
                ...rest,
                tagType: `/api/tag_types/${tagTypeId}`,
            };
            const response = await loggedInApiCall.post("/api/tag_values", payload);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["getAllTagValues"]);
            queryClient.invalidateQueries(["getAllTagTypes"]);
        },
    });

    return mutation;
};
